const users = [
  {
    username: "amit",
    userimage: "https://avatars.githubusercontent.com/u/48612930?v=4",
    displayName: "Amit Rout",
    biograpfy: "Frontend Developer",
    followingCount: 158,
    followersCount: 250,
    joinYear: 2011,
    joinMonth: "December",
  },
  {
    username: "Jaky12",
    userimage:
      "https://images.unsplash.com/photo-1650594122465-7608fcd64620?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw1NHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60",
    displayName: "Jatin Sahoo",
    biograpfy: "Software Engineer",
    followingCount: 18,
    followersCount: 20,
    joinYear: 2017,
    joinMonth: "May",
  },
  {
    username: "ahmed",
    userimage:
      "https://images.unsplash.com/photo-1553272725-086100aecf5e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=465&q=80",
    displayName: "ahmed",
    biograpfy: "UI/UX Developer",
    followingCount: 558,
    followersCount: 250,
    joinYear: 2012,
    joinMonth: "April",
  },
];

export default users;
